import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { Capacitor } from "@capacitor/core";
import { router } from "@/app/router";
import { App } from "@/app/App";
import { registerDeepLinks } from "@/features/auth/deepLinks";
import "@/index.css";
// Side-effect import: bootstraps react-i18next with the French resources.
// Must run before React renders or every `t(...)` call falls back to the raw key.
import "@/lib/i18n";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT ?? "development",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});

// GTM is loaded via the snippet in index.html.
// Push SPA route changes so GTM's GA4 tag fires on every navigation — web only.
if (!Capacitor.isNativePlatform()) {
  window.dataLayer = window.dataLayer ?? [];
  router.subscribe((state) => {
    if (state.navigation.state === "idle") {
      window.dataLayer.push({
        event: "page_view",
        page_path: state.location.pathname,
      });
    }
  });
}

// Native: route fr.batchcooking.app://auth/callback deep links (magic links)
// into the SPA with their query intact — no-op on the web.
void registerDeepLinks((path) => void router.navigate(path));

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
